import { useEffect, useRef } from 'react';

type MessageEventListener = (event: MessageEvent) => void;

const useEventListener = (
    handler: MessageEventListener,
    element: HTMLElement | Window = window,
) => {
    const savedHandler = useRef<MessageEventListener>(undefined);

    useEffect(() => {
        savedHandler.current = handler;
    }, [handler]);

    useEffect(() => {
        const isSupported = element && element.addEventListener;
        if (!isSupported) return;
        const eventListener = (event: Event) =>
            savedHandler.current?.(event as MessageEvent);
        element.addEventListener('message', eventListener);
        return () => {
            element.removeEventListener('message', eventListener);
        };
    }, [element]);
};

export default useEventListener;
